import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { authFetch } from "@/lib/auth";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace("#", "?"));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await authFetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (res.ok) {
          const userData = await res.json();
          setUser(userData);
          navigate("/dashboard", { replace: true });
        } else {
          const errorData = await res.json().catch(() => ({}));
          console.error("OAuth session exchange failed:", res.status, errorData);
          navigate("/", { replace: true });
        }
      } catch (err) {
        console.error("OAuth callback error:", err);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F0F4F8]">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-[#0066FF] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#4A5568] font-body">Autenticando...</p>
      </div>
    </div>
  );
}
